<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Adicionando documento
    </template>
    <template>
      <v-row dense>
        <v-col cols="10">
          <v-text-field
            dense
            outlined
            hide-details
            class="required rounded-tag-small"
            label="Título"
            maxlength="150"
            :error="$v.documento.titulo.$error"
            @blur="$v.documento.titulo.$touch()"
            v-model="documento.titulo"
          />
        </v-col>
        <v-col cols="2">
          <px-anexo v-model="documento.arquivos" :max="1" @loading="onFileLoad"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            label="Descrição"
            counter="1500"
            rows="3"
            v-model="documento.descricao"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-date-picker dense
                          input-class="required rounded-tag-small"
                          label="Data de Inicio"
                          clearable
                          :error="$v.documento.dataInicio.$error"
                          @blur="$v.documento.dataInicio.$touch()"
                          v-model="documento.dataInicio"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-date-picker dense
                          input-class="required rounded-tag-small"
                          label="Data de Fim"
                          clearable
                          :error="$v.documento.dataLimite.$error"
                          @blur="$v.documento.dataLimite.$touch()"
                          v-model="documento.dataLimite"/>
        </v-col>
      </v-row>
      <v-row v-if="documento.dataInicio && documento.dataLimite">
        <v-col cols="12" sm="12">
          <v-checkbox
            v-model="documento.notifica"
            color="primary"
          >
            <template v-slot:label>
              <div class="text--primary">
                Deseja ser notificado sobre a expiração do contrato?
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <template v-if="documento.notifica && documento.dataInicio && documento.dataLimite">
        <v-row dense>
          <v-col cols="12" sm="12">
            <v-text-field
              dense
              outlined
              hide-details
              type="email"
              class="rounded-tag-small"
              label="Email para ser notificado"
              maxlength="100"
              :error="$v.documento.email.$error"
              @blur="$v.documento.email.$touch()"
              v-model="documento.email"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="8">
            <v-text-field
              dense
              outlined
              hide-details
              type="whatsapp"
              class="rounded-tag-small"
              label="Whatsapp para ser notificado"
              v-mask="['(##) #####-####', '(##) # ####-####']"
              maxlength="20"
              :error="$v.documento.whatsapp.$error"
              @blur="$v.documento.whatsapp.$touch()"
              v-model="documento.whatsapp"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              dense
              outlined
              hide-details
              class="rounded-tag-small"
              label="Dias"
              maxlength="3"
              :error="$v.documento.diasNotificar.$error"
              @blur="$v.documento.diasNotificar.$touch()"
              v-model="documento.diasNotificar"
            >
              <template v-slot:append>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>
                    Aqui você informa quantos dias
                    antes do vencimento do contrato
                    você deseja ser notificado.
                    </span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </template>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loadingDocumento"
             :disabled="$v.$invalid || hasFileLoading || !hasFiles"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  required, requiredIf, email, minLength, numeric,
} from 'vuelidate/lib/validators';
import { cloneDeep, first } from 'lodash';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      dialog: false,
      loadingDocumento: false,
      hasFileLoading: false,
      documento: {
        titulo: null,
        descricao: null,
        arquivos: [],
        dataInicio: null,
        dataLimite: null,
        email: null,
        whatsapp: null,
        diasNotificar: null,
        notifica: false,
      },
    };
  },
  computed: {
    hasFiles() {
      return this.documento.arquivos && this.documento.arquivos.length;
    },
    ...mapGetters('user', ['user', 'loading']),
  },
  methods: {
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
    close() {
      this.dialog = false;
    },
    buildPayload() {
      if (this.documento.email == null && this.documento.notifica) {
        this.documento.email = this.user.email;
      }
      if (this.documento.whatsapp == null && this.documento.notifica) {
        this.documento.whatsapp = this.user.whatsapp;
      }
      if (this.documento.diasNotificar === null) {
        this.documento.diasNotificar = 0;
      }
      const payload = cloneDeep(this.documento);
      payload.arquivo = first(payload.arquivos);
      payload.arquivos = undefined;
      payload.detalheFornecedor = {
        id: this.fornecedor.id,
      };
      return payload;
    },
    save() {
      this.loadingDocumento = true;
      GestaoFornecedorService.saveDocumento(this.fornecedor.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$toast('Documento incluído', { color: 'success' });
          this.$emit('update');
        })
        .finally(() => {
          this.loadingDocumento = false;
        });
    },
  },
  validations: {
    documento: {
      titulo: {
        required,
      },
      dataInicio: {
        required: requiredIf(function () {
          return this.documento.dataLimite;
        }),
      },
      dataLimite: {
        required: requiredIf(function () {
          return this.documento.dataInicio;
        }),
      },
      email: {
        email,
      },
      diasNotificar: {
        required: requiredIf(function () {
          return this.notifica;
        }),
        numeric,
      },
      whatsapp: {
        minLength: minLength(15),
      },
    },
  },
};
</script>
